import { useQuery } from '@tanstack/react-query';
import { endpoints, Url } from '@rossum/api-client';
import { QueueRule, SchemaSection } from '@rossum/api-client/schemas';
import { useApiClient } from '../../../lib/apiClient';

export const useSuggestTriggerConditionSummary = (
  payload:
    | {
        queue: Url;
        schemaContent: SchemaSection[];
        schemaRule: Partial<QueueRule>;
      }
    | undefined,
  { enabled }: { enabled?: boolean } = {}
) => {
  const api = useApiClient();
  return useQuery({
    queryKey: ['rule-condition-summary', payload] as const,
    queryFn: () => {
      const payloadWithRuleName = {
        ...payload,
        queue: payload!.queue,
        schemaRule: {
          ...payload!.schemaRule,
          name: 'No name',
        },
      };
      return api.request(
        endpoints.internal.rules.suggestTriggerConditionSummary(
          payloadWithRuleName
        )
      );
    },
    enabled:
      payload !== undefined &&
      payload.schemaRule.triggerCondition !== '' &&
      enabled,
    select: data => data.results[0]?.triggerConditionSummary,
  });
};
